import { createClient } from "@supabase/supabase-js";
import { inMemoryStorage } from "@/providers/storage/inMemoryStorage";
import { ENV } from "@/providers/env";

const supabaseUrl = ENV.SUPABASE_URL;
const supabaseAnonKey = ENV.SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: inMemoryStorage,
    persistSession: false,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});

export const REFRESH_TOKEN_KEY = "admin_refresh_token";
